import {de_DE_formal} from '@App/locales/de_DE-formal';
import {de_DE_globalTranslations} from "@App/locales/de_DE-globalTranslations";

export const deutscheleasing = {
    ...de_DE_formal,
    ...{
        translation: {
            ...de_DE_globalTranslations.translation,
            hero: {
                'title': 'Willkommen bei der Servicepartnersuche und Online-Terminvereinbarung der Deutschen Leasing',
                'subtitle': null,
            },
            layout: {
                backText: 'Zurück zu deutsche-leasing.com'
            },
            linkToHome: 'https://werkstatt.repareo.de/partner/deutsche-leasing',
            benefits: {
                'title': 'Ihre Vorteile',
                'bullet-point-1': 'Freie Termine direkt online buchen',
                'bullet-point-2': 'Die besten Werkstattpartner auf einen Blick – bewertet nach den Qualitätsstandards der Deutschen Leasing',
                'bullet-point-3': 'Exklusive Zusatzservices wie Hol- und Bring und Ersatzfahrzeug hinzufügen',
                'feedbackText': 'Sie haben Anregungen oder etwas funktioniert nicht wie erwartet? Wir würden es gerne erfahren.',
                'feedbackTitle': 'Feedback'
            },
            contactForm: {
                benefits: {
                    'benefit-1': 'Kostenfreie Stornierung',
                    'benefit-2': 'Alle Infos per E-Mail',
                    'benefit-3': 'Bitte besprechen Sie mit der Werkstatt, welche Kosten ggf. über einen bestehenden Servicevertrag für Wartung & Reparatur mit der Deutschen Leasing abgerechnet werden können.'
                },
                placeholders: {
                    'first-name': 'Vorname*',
                    'last-name': 'Nachname*',
                    'email': 'E-Mail*',
                    'phone': 'Telefon für Rückfragen*',
                    'street': 'Strassenname und Hausnummer',
                    'postcode': 'Postleitzahl',
                    'city': 'Wohnort',
                    'addition': 'Adresszusatz',
                    'message': 'Anmerkungen (optional)',
                    'message-required': 'Anmerkungen',
                },
            },
            listHints: {
                'shownAsNonBookable': 'Bitte kontaktieren Sie die Werkstatt telefonisch zur Terminvereinbarung, da für den Reifenersatz spezifische Informationen zu den Reifen benötigt werden.',
                'availableServicesListItemTitle': 'Optionale Zusatzservices',
                'leasingVehicleReturn': 'Leasingfahrzeug Rückgabe',
                'callBacks': 'Rückrufaktionen',
                'mobileService': ' mobiler Vor-Ort-Service',
                'glasRepair': 'Glasreparatur und Tausch',
                'ourTip': 'Unsere Auswahl',
                'sortedByDistance': 'Alle Werkstätten sortiert nach Distanz',
                'furtherGaragesSortedByDistance': 'Weitere Werkstätten sortiert nach Distanz',
            },
            garageList: {
                filters: {
                    premiumServices: {
                        'additional-cost-info': '*Verfügbarkeit vorausgesetzt, führt zu zusätzlichen Kosten',
                    }
                },
            },
            hint: {
                'text': 'Alle gezeigten Werkstätten sind offizielle DEUTSCHE LEASING Servicepartner und für Sie freigegeben (gem. vertraglicher Vereinbarung). Bitte nutzen Sie die Möglichkeit der Online-Terminvereinbarung.',
                'repareo-inspection-text': 'Alle gezeigten Werkstätten sind offizielle DEUTSCHE LEASING Servicepartner und für Sie freigegeben (gem. vertraglicher Vereinbarung). Bitte nutzen Sie die Möglichkeit der Online-Terminvereinbarung.',
            },
        },
    }
}
